// Components, Layouts, Pages
import { PublicLayout } from '~/layouts';
import { GoogleCallBack, JobReviewPublic, QuickBookCallBack } from '~/pages/public';
// Others
import { IRouteModel } from '~/utils/interface/base';

export const publicRoute = {
  base: '/',
  jobReview: '/job-review',
  googleCallback: '/googles/call-back',
  quickBookCallback: '/quick-book/call-back',
};

export const routesPublic: IRouteModel[] = [
  {
    path: publicRoute.base,
    component: PublicLayout,
    children: [
      {
        index: true,
        path: `${publicRoute.base}${publicRoute.jobReview}`,
        component: JobReviewPublic,
      },
      {
        path: `${publicRoute.base}${publicRoute.googleCallback}`,
        component: GoogleCallBack,
      },
      {
        path: `${publicRoute.quickBookCallback}`,
        component: QuickBookCallBack,
      },
    ],
  },
];
